export default {
   getHasNotification: (state) => {
      return state.hasNotification;
   },
   
   getHasSoundEffect: (state) => {
      return state.hasSoundEffect;
   }
}